const RegisterFormTOSPositionEnum = {
  TOP: 'top',
  BOTTOM: 'bottom',
  NONE: 'none',
};

export default RegisterFormTOSPositionEnum;



// WEBPACK FOOTER //
// ./src-react/RegisterForm/RegisterFormConstants.jsx